// extracted by mini-css-extract-plugin
export default {"input":"TextInput_input__e85SP","lg":"TextInput_lg__VQqto"};